import ReplaceFilter from './replace_filter'
import connect from './connect'

export default connect(ReplaceFilter)
